import request from '../request';
import qs from 'qs'

interface IthPop{
    isLeadMilestoneIsOpen: boolean
    isOpen: boolean
    leadIsOpen: boolean
    leadMilestoneUrl: string
    leadUrl: string
    url: string
}
interface CybrosRes<T>{
    error: any,
    status: T
}
// 红点
export const getIthPopApi = async (username: string) => {
    return await request.get<any, IthPop>('/workbenchApi/health/worktimes', {
        params: {
            username,
        },
    });
};
// 是否显示
export const getIthPopStatusApi = async () => {
    return await request.get<any, IthPop>('/workbenchApi/worktimes/audit-status');
};
export const getIthWhiteListApi = async (username: string) => {
    return await request.get < any, { canFill: boolean }>('/workbenchApi/health/get-can-fill', {
        params: {
            username,
        },
    });
};
export const getIthWorktimeApi = async (email: string) => {
    return await request.get < any, CybrosRes<{ filled: boolean }>>('/cybros_api/plm_status.json', {
        params: {
            email,
        },
    });
};
export const addIthPopLogApi = async (username: string, operationType: string) => {
    return await request.get<any, { canFill: boolean }>('/workbenchApi/health/open-worktime-log', {
        params: {
            username,
            operationType,
        },
    });
};